import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { Label } from '@/@bothrs-ui/web/components/forms/label'
import { FlexRow } from '@/@bothrs-ui/web/components/layout/flex/Flex'
import { useLocale, useSetLocale } from '../locale-atom'

import type React from 'react'

type LanguageSelectorProps = {
  className?: string
  style?: React.CSSProperties
}

/**
 * Component for selecting languages
 * Renders a button for each available language
 */
export const LanguageSelector = ({ className, style }: LanguageSelectorProps) => {
  const theme = useTheme()
  const locale = useLocale()
  const setLocale = useSetLocale()

  const languages = [
    { code: 'nl', name: 'Nederlands' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
  ] as const

  return (
    <div className={className} style={style}>
      <Label color={theme.Colors.Neutrals.Darker} type='BodyMediumBold'>
        {t({
          id: 'profile.debug-settings.language-title',
          message: 'Kies taal',
        })}
      </Label>
      <FlexRow gap={theme.UI.Spacing.Space2}>
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => setLocale(language.code)}
            style={{
              padding: '8px 16px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: locale === language.code ? '#007bff' : '#fff',
              color: locale === language.code ? '#fff' : '#000',
            }}
          >
            {language.name}
          </button>
        ))}
      </FlexRow>
    </div>
  )
}
